<template>
  <CFooter :fixed="false">
    <div>
      <a href="javascript:void(0);" target="_blank">Kapok</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Kapok.</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
